/* eslint-disable no-undef */
import React, { useEffect, useState } from "react";
import "../../css/mobile-intro/mobile-intro.css";
import { useNavigate } from "react-router-dom";
import { isMobile } from "react-device-detect";
import axios from "axios";
import config from "../../config";

export default function GoTruck() {
  const isIOS = /(iPad|iPhone|iPod|Mac).*AppleWebKit(?!.*Safari)/i.test(navigator.userAgent) && !window.MSStream;
  const [opacity, setOpacity] = useState(0);
  const [opacityLeft, setOpacityLeft] = useState(0);
  const [opacityRight, setOpacityRight] = useState(0);
  const [leftX, setLeftX] = useState("-250px");
  const [rightX, setRightX] = useState("-250px");
  const navigate = useNavigate();
  const servicePhoneNum = "010-4478-8944";

  const [priceData, setPriceData] = useState([]);


  const callTodayMain = async () => {
    axios({
      url: config.API_URL + "/comm/mValueListWithDiff",
      method: "post",
      data: {},
      headers: {
        ...axios.defaults.headers,
        Authorization: "",
      },
    }).then((res) => {
      const data = res?.data?.resultList;

      setPriceData(data);
    });
  };




  const currentMonth = new Date().getMonth() + 1;

  useEffect(() => {
    callTodayMain();
    setLeftX("0px");
    setRightX("0px");

    setTimeout(function () {
      setOpacity(1);
    }, 300);
  }, []);

  const goToPhonCallApp = () => {
    const digitsOnly = servicePhoneNum.replace(/-/g, "");
    if (!isMobile) {
      alert("전화는 모바일에서만 가능합니다.");
      return;
    }
    if ((typeof TOPTOP_APP) === 'object' && (typeof TOPTOP_APP.makePhoneCall) === 'function') {
      TOPTOP_APP.makePhoneCall(digitsOnly);
    } else if (isIOS) {
      webkit.messageHandlers.makePhoneCall.postMessage(digitsOnly);
    } else {
      window.location.href = `tel:${digitsOnly}`;
    }
  };

  return (
    <div className="mobile-intro-wrapper" style={{ maxWidth: "500px", margin: "0 auto", width: "100%" }}>
      <div className="header" style={{ marginTop: "10px", display: "flex", justifyContent: "space-between", alignItems: "center", boxShadow: "none" }}>
        <div className="header-text" style={{ textAlign: "left", lineHeight: "1.3", fontSize: "22px" }}>
          빠르고 안전한<br />영업용넘버 거래는
        </div>
        <div className="header-img" style={{ marginTop: 0 }}>
          <img
            src={process.env.PUBLIC_URL + `/img/mobile-top-logo.png`}
            alt="TOPTOP Logo"
            style={{ maxWidth: "200px", height: "auto" }}
          />
        </div>
      </div>

      <div className="section" style={{ paddingTop: "15px", paddingBottom: "15px" }}>
        <div style={{
          border: "2px solid #F48A1B",
          borderRadius: "20px",
          padding: "20px 15px",
          background: "#fff",
          width: "100%"
        }}>


          <div className="d-flex justify-content-between align-items-center fw-bold mb-3">
            <span style={{ fontSize: "20px", color: "#F48A1B", fontWeight: "bold" }}>
              {currentMonth}월 넘버 시세
            </span>
            <span style={{ fontSize: "16px", color: "#335EA4", fontWeight: "bold" }}>지난 주 대비</span>
          </div>


          <div className="price-list-wrapper">
            {priceData.map((item, index) => {
              let carTitle = "";
              let carDesc = "";
              if (item?.car_weight_cd === 2301) { carTitle = "소형"; carDesc = "(1.5톤 이하)"; }
              else if (item?.car_weight_cd === 2302) { carTitle = "중형"; carDesc = "(1.5톤~16톤 이하)"; }
              else if (item?.car_weight_cd === 2303) { carTitle = "대형"; carDesc = "(16톤 초과)"; }
              else if (item?.car_weight_cd === 2304) { carTitle = "전기차"; carDesc = ""; }
              else { carTitle = "영업용 넘버"; carDesc = ""; }


              const rawChange = item?.price_diff;
              let priceChangeText = "변동없음";
              let badgeColor = "#A6A6A6";

              if (rawChange !== undefined && rawChange !== null && rawChange !== 0 && rawChange !== "0" && rawChange !== "변동없음") {
                if (typeof rawChange === 'number') {

                  if (rawChange > 0) {
                    priceChangeText = `+${rawChange}만원`;
                    badgeColor = "#F48A1B";
                  } else if (rawChange < 0) {
                    priceChangeText = `${rawChange}만원`;
                    badgeColor = "#335EA4";
                  }
                } else {

                  priceChangeText = String(rawChange);
                  if (priceChangeText.includes("+")) badgeColor = "#F48A1B";
                  else if (priceChangeText.includes("-")) badgeColor = "#335EA4";
                }
              }


              let badgeStyle = {
                display: "inline-block",
                padding: "6px 12px",
                borderRadius: "8px",
                fontSize: "15px",
                minWidth: "85px",
                textAlign: "center",
                color: "#fff",
                fontWeight: "bold",
                backgroundColor: badgeColor
              };


              return (
                <div key={index} className="d-flex justify-content-between align-items-center py-3 border-bottom" style={{ borderBottom: "1px solid #f2f4f4" }}>

                  <div style={{ fontSize: "16px", color: "#335EA4", fontWeight: "bold", width: "38%", lineHeight: "1.3", textAlign: "left" }}>
                    {carTitle}
                    {carDesc && (
                      <>
                        <br />
                        <span style={{ fontSize: "14px", fontWeight: "bold" }}>{carDesc}</span>
                      </>
                    )}
                  </div>


                  <div style={{ fontSize: "18px", fontWeight: "bold", color: "#000", width: "35%", whiteSpace: "nowrap", textAlign: "right", paddingRight: "5px" }}>
                    {(item?.current_avg_price || 0).toLocaleString()}만원
                  </div>

                  <div style={{ width: "27%", textAlign: "right" }}>
                    <span style={badgeStyle}>
                      {priceChangeText}
                    </span>
                  </div>

                </div>
              );
            })}
          </div>
        </div>
      </div>

      <div style={{ padding: "0 10px", marginBottom: "15px" }}>
        <button
          type="button"
          onClick={() => window.open("/", "_blank")}
          className="w-100 d-flex justify-content-center align-items-center"
          style={{
            background: "#344454",
            color: "#fff",
            border: "none",
            borderRadius: "12px",
            height: "56px",
            fontSize: "18px",
            fontWeight: "bold",
            cursor: "pointer"
          }}
        >
          매물 보러가기
        </button>
      </div>

      <div className="footer">
        <div className="phone-box">
          <div className="phone-inner">
            <div className="phone-text">
              <div
                className="phone"
                style={{ cursor: isMobile ? "pointer" : "default" }}
                onClick={() => { if (isMobile) goToPhonCallApp(); }}
              >
                고객센터 연결
              </div>
              <div className="fw-bold" style={{fontSize : "16px"}}>(평일 09:00~18:00)</div>
            </div>
            <img
              src={"/img/icon_phone.svg"}
              alt="Call"
              style={{ width: "80px", height: "80px", cursor: "pointer" }}
              onClick={() => { if (isMobile) goToPhonCallApp(); }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}